// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { GaContextAsp, Language, GaContextCustomer, GaContextFlags, GaContextDataSync } from "../schema";
import { serialize_GaContextAsp_internal, deserialize_GaContextAsp_internal } from "./GaContextAsp";
import { serialize_Language_internal, deserialize_Language_internal } from "./Language";
import { serialize_GaContextCustomer_internal, deserialize_GaContextCustomer_internal } from "./GaContextCustomer";
import { serialize_GaContextFlags_internal, deserialize_GaContextFlags_internal } from "./GaContextFlags";

export function serialize_GaContextDataSync_internal(value: GaContextDataSync): unknown {
  return ((value: { asp: GaContextAsp | null; currentLanguage: Language; customer: GaContextCustomer | null; flags: GaContextFlags }): unknown => {
    return {
      asp: ((value: GaContextAsp | null): unknown => {
        if (value === null) {
          return null;
        }
        return serialize_GaContextAsp_internal(value);
      })(value["asp"]),
      currentLanguage: ((value: Language): unknown => {
        return serialize_Language_internal(value);
      })(value["currentLanguage"]),
      customer: ((value: GaContextCustomer | null): unknown => {
        if (value === null) {
          return null;
        }
        return serialize_GaContextCustomer_internal(value);
      })(value["customer"]),
      flags: ((value: GaContextFlags): unknown => {
        return serialize_GaContextFlags_internal(value);
      })(value["flags"]),
    };
  })(value);
}
export function serialize_GaContextDataSync(obj: GaContextDataSync): string {
  return renderJsonWithNumbersAsBigint(serialize_GaContextDataSync_internal(obj));
}
export function deserialize_GaContextDataSync_internal(value: unknown): ParserResult<GaContextDataSync> {
  return ((
    value: unknown,
  ): ParserResult<{
    asp: GaContextAsp | null;
    currentLanguage: Language;
    customer: GaContextCustomer | null;
    flags: GaContextFlags;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/GaContextDataSync]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/GaContextDataSync]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "asp")) {
      return { success: false, reason: `[#/components/schemas/GaContextDataSync/asp]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'asp'.` };
    }
    const parsed_asp = ((): ParserResult<GaContextAsp | null> => {
      return ((value: unknown): ParserResult<GaContextAsp | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return deserialize_GaContextAsp_internal(value);
      })(value["asp"]);
    })();
    if (!parsed_asp.success) {
      return { success: false, reason: parsed_asp.reason };
    }
    if (!hasProp(value, "currentLanguage")) {
      return { success: false, reason: `[#/components/schemas/GaContextDataSync/currentLanguage]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'currentLanguage'.` };
    }
    const parsed_currentLanguage = ((): ParserResult<Language> => {
      return ((value: unknown): ParserResult<Language> => {
        return deserialize_Language_internal(value);
      })(value["currentLanguage"]);
    })();
    if (!parsed_currentLanguage.success) {
      return { success: false, reason: parsed_currentLanguage.reason };
    }
    if (!hasProp(value, "customer")) {
      return { success: false, reason: `[#/components/schemas/GaContextDataSync/customer]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customer'.` };
    }
    const parsed_customer = ((): ParserResult<GaContextCustomer | null> => {
      return ((value: unknown): ParserResult<GaContextCustomer | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return deserialize_GaContextCustomer_internal(value);
      })(value["customer"]);
    })();
    if (!parsed_customer.success) {
      return { success: false, reason: parsed_customer.reason };
    }
    if (!hasProp(value, "flags")) {
      return { success: false, reason: `[#/components/schemas/GaContextDataSync/flags]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'flags'.` };
    }
    const parsed_flags = ((): ParserResult<GaContextFlags> => {
      return ((value: unknown): ParserResult<GaContextFlags> => {
        return deserialize_GaContextFlags_internal(value);
      })(value["flags"]);
    })();
    if (!parsed_flags.success) {
      return { success: false, reason: parsed_flags.reason };
    }
    return { success: true, value: { asp: parsed_asp.value, currentLanguage: parsed_currentLanguage.value, customer: parsed_customer.value, flags: parsed_flags.value } };
  })(value);
}
export function deserialize_GaContextDataSync(str: string): ParserResult<GaContextDataSync> {
  return deserialize_GaContextDataSync_internal(parseJsonWithNumbersAsBigint(str));
}
